import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SearchService } from '@app/core/services/search/base.search.service';
import { BuildProgrammeLogicService } from '@app/logic/build-programme';
import { CouncilLogicService } from '@app/logic/councils';
import { ICouncilDto } from '@app/logic/councils/interfaces/i.council.dto';
import { takeOne } from 'cb-hub-lib';
import { map, Observable, take } from 'rxjs';
import { getBaseFormComponentDirectiveProvider } from '../../../base-form-component';
import { AutocompleteScrollerComponent, getBaseAutocompleteScrollerProvider } from '../../autocomplete-scroller.component';

@Component({
    selector: 'cb-council-autocomplete-scroller',
    templateUrl: '../../autocomplete-scroller.component.html',
    providers: [
        ...getBaseFormComponentDirectiveProvider(CouncilAutocompleteScrollerComponent),
        getBaseAutocompleteScrollerProvider(CouncilAutocompleteScrollerComponent),
        SearchService,
    ],
    standalone: false
})
export class CouncilAutocompleteScrollerComponent
    extends AutocompleteScrollerComponent<ICouncilDto> {
    public results: ICouncilDto[] = [];
    private resultsLoaded = false;

    constructor(
        public readonly buildProgrammeLogicService: BuildProgrammeLogicService,
        public readonly dialog: MatDialog,
        public readonly searchService: SearchService,
        protected readonly councilLogicService: CouncilLogicService
    ) {
        super(dialog, searchService);
        this.searchService.doSearch = this.doSearch;
    }

    public doSearch = (query: string): Observable<any[]> => {
        return this.getResults()
            .pipe(takeOne(), map((results) => {
                const filtered = results.filter(x =>
                    (this.displayWith(x) || '').toLowerCase().indexOf(query.toLowerCase()) > -1
                );
                return filtered;
            }));
    };

    public displayWith(item: any): string {
        return item ? item.name : null;
    }

    private getResults(): Observable<ICouncilDto[]> {
        return new Observable<ICouncilDto[]>((subscriber) => {
            if (!this.resultsLoaded) {
                this.resultsLoaded = true;
                const resultsObservable = this.councilLogicService.$getList();
                resultsObservable
                    .pipe(take(1)).subscribe(x => {
                        this.results = x;
                        subscriber.next(this.results);
                        subscriber.complete();
                    });
            } else {
                subscriber.next(this.results);
                subscriber.complete();
            }
        });
    }
}
